module.exports = __webpack_public_path__ + "img/1bbb57a.jpg";